// src/api/auth.js
import esupplyvetApi from "./esupplyvet";
import api from "./index";
import { getFromCache, saveToCache, removeFromCache } from "@/utils/cacheUtils";
import { useRegisterStore } from "@/stores/register";

export function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}
/*******************************Module Auth********************************/
export function login(email, password, type) {
  const loginUrl = type === "clients" ? esupplyvetApi : api;
  return loginUrl.post("/customers/token", { email, password, type });
}

export function ForgetPassword(email) {
  const response = getHttpClient().post("/customers/reset-password", { email });
  return response;
}
export function ResetPassword(token, newPassword, confirmNewPassword) {
  const response = getHttpClient().patch(`/customers/reset-password/${token}`, {
    newPassword,
    confirmNewPassword,
  });
  return response;
}
export function registerProprietaire(payload) {
  return esupplyvetApi.post("/customers/register-proprietaire", payload);
}
export function AccountVerify(token) {
  return getHttpClient().patch(`/customers/verify/${token}`, {});
}
export function getCountries() {
  return getHttpClient().get("/countries?page=1&itemsPerPage=100&Accept-Language=fr_FR");
}
export function UpdatePassword(customer_id, payload) {
  const response = getHttpClient().put(`/customers/${customer_id}/password`, payload);
  response
    .then(() => {
      invalidateCustomerCache(customer_id);
    })
    .catch(() => {});
  return response;
}
export function UpdateInfosPersonnelles(payload) {
  const response = getHttpClient().post("/modif-informations/send-email", payload);
  return response;
}
export function getVeterinaire(id, forceRefresh = false) {
  const cacheKey = `veterinaire_${id}`;
  const cached = getFromCache(cacheKey);
  if (cached&& !forceRefresh) {
    console.log(`Cache hit pour vétérinaire ${id}`);
    return Promise.resolve({ data: cached, fromCache: true });
  }
  console.log(`Cache miss pour vétérinaire ${id}, appel API`);
  return getHttpClient()
    .get(`/customers/${id}`)
    .then(response => {
      saveToCache(cacheKey, response.data);
      console.log(`Données vétérinaire ${id} sauvegardées en cache`);
      return response;
    })
    .catch(error => {
      console.error(`Erreur API pour vétérinaire ${id}:`, error);
      throw error;
    });
}

export function invalidateCustomerCache(customerId) {
  removeFromCache(`veterinaire_${customerId}`);
  removeFromCache(`customer_${customerId}`);
  console.log(`Cache invalidé pour customer ${customerId}`);
}

export function changeVeterinarian(veterinaryCode) {
  return getHttpClient().put(`/customers/propritaire/changer-veto/${veterinaryCode}`, {});
}

export function getDelegues() {
  return getHttpClient().get("/customers/delegues");
}
/************************Module Produits******************************/
export function getProducts(page = 1, itemsPerPage = 30, searchQuery,code,orderBy,isDelegate = false, vetId = null) {

    let url = `/products?page=${page}&itemsPerPage=${itemsPerPage}`;
        if (searchQuery) {
          url += `&translations.name=${encodeURIComponent(searchQuery)}`; 
        }
         if (code) {
          url += `&productTaxons.taxon.code=${code}`; 
        }
         if (orderBy) {
          url += `&${orderBy}`;
        }
        if (isDelegate && vetId) {
          const params = new URLSearchParams();
          params.append('isDelegate', '1');
          params.append('vetId', vetId);
          url += `&${params.toString()}`;
        }
        
      
    return getHttpClient().get(url, {
            headers: { Accept: 'application/ld+json' },
          });
  
}
export function getProductsTaxon(code, { page = 1, itemsPerPage = 30, orderBy = "",isDelegate = false, vetId = null} = {}) {
  let url = `/products?productTaxons.taxon.code=${code}&page=${page}&itemsPerPage=${itemsPerPage}`;
  if (orderBy) url += `&${orderBy}`;
  if (isDelegate && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    url += `&${params.toString()}`;
  }
  return getHttpClient().get(url, { headers: { Accept: "application/ld+json" } });
}
export function getProductsByTaxonId(taxonId, page = 1, itemsPerPage = 30,isDelegate = false, vetId = null) {
  if (isDelegate && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    return getHttpClient().get(`/products?page=${page}&itemsPerPage=${itemsPerPage}&productTaxons.taxon.id=${taxonId}&${params.toString()}`);
  }
  return getHttpClient().get(`/products?page=${page}&itemsPerPage=${itemsPerPage}&productTaxons.taxon.id=${taxonId}`);
}
export function getSortProducts(orderBy) {
  return getHttpClient().get(`/products?${orderBy}`);
}
export function getProductVariant(code) {
  return getHttpClient().get(`/product-variants/${code}`);
}
export function getProductTaxon(id) {
  return getHttpClient().get(`/product-taxons/${id}`);
}
export function PostFavoriteProduct(prod_id) {
  return getHttpClient().post(`/favorites/${prod_id}`, {});
}
export function DeleteFavoriteProduct(prod_id) {
  return getHttpClient().delete(`/favorites/${prod_id}`);
}

export function GetFavoriteProducts() {
  return getHttpClient().get(`/product-favoris`);
}


export function getProduct(slug,isDelegate = false, vetId = null) {
  let url = `/products-by-slug/${slug}`;
   if (isDelegate && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    url += `?${params.toString()}`;
  }

  return getHttpClient().get(url);
}
/************************Module Taxon*****************************/
export function getTaxons(isDelegate = false, vetId = null) {

  let url = "/taxons";

   if (isDelegate && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    url += `?${params.toString()}`;
  }
  return getHttpClient().get(url);
}
export function getTaxon(code) {
  return getHttpClient().get(`/taxons/${code}`);
}
/************************Module Cart******************************/
export function CreateNewCart(channel, isDelegate = false, vetId = null) {
  let url = "/orders";
  
  // Add query parameters if provided
  if (isDelegate && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    url += `?${params.toString()}`;
  }

  return getHttpClient().post(url, {
    channel: `/api/v2/shop/channels/${channel}`,
  });
}
export function applyPromotionDelegue(promotionPayload) {
  return getHttpClient().post(`/promotions`, promotionPayload);
}


export function getCart(CartToken) {
  return getHttpClient().get(`/orders/${CartToken}`);
}
export function getCartWithOutToken() {
  return getHttpClient().get(`/orders`);
}
export function addItemToCart(CartToken, variantCode, quantity, freeQuantity = 0, isDelegate = false, vetId = null, isUg = null,ugQuantity = 0) {
  let totalQuantity = quantity;
  
  const payload = {
    productVariant: `/api/v2/shop/product-variants/${variantCode}`,
    quantity: totalQuantity
  };

  if (freeQuantity && freeQuantity > 0) {
    totalQuantity += freeQuantity;
    payload.quantity = totalQuantity;
  }

  // Build base URL
  let url = `/orders/${CartToken}/items`;
  
  // Append query parameters if isDelegate is true and vetId is provided
  if (isDelegate && vetId) {
    const params = new URLSearchParams({
      isDelegate: '1',
      vetId: vetId,
      isUg: isUg ? true : false,
      ugQuantity : ugQuantity ? ugQuantity : 0

    });
    url += `?${params.toString()}`;
  }

  return getHttpClient().post(url, payload);
}
export function UpdateItemCart(CartToken, ItemId, quantity, isDelegate = false, vetId = null) {
  let url = `/orders/${CartToken}/items/${ItemId}`;
  if (isDelegate && vetId) {
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    params.append('vetId', vetId);
    url += `?${params.toString()}`;
  }
  
  return getHttpClient().patch(url, { quantity });
}
export function removeItemFromCart(CartToken, itemId) {
  return getHttpClient().delete(`/orders/${CartToken}/items/${itemId}`);
}
export function clearItemsCart(CartToken) {
  return getHttpClient().delete(`/orders/${CartToken}`);
}
/************************Module Service******************************/
export function getServices() {
  return getHttpClient().get("/contact-services");
}
export function getObjets() {
  return getHttpClient().get("/form-contacts-objets");
}
export function SendContact(payload) {
  return getHttpClient().post("/form-contacts", payload);
}
/************************Module Faq******************************/
export function getFaqs(isClient) {
  const apiInstance = isClient ? esupplyvetApi : api;
  return apiInstance.get("/faqs");
}
export function getFaqsFooter(isClient) {
  const apiInstance = isClient ? esupplyvetApi : api;
  return apiInstance.get("/faqs?showInFooter=1");
}
/************************Module Documents************************/
export function getDocuments() {
  return getHttpClient().get("/document-categories");
}
export function getDocument(id) {
  return getHttpClient().get(`/documents/${id}`);
}
/************************Module Shipping Methodes******************************/
export function getShippingMethodes(userRole = null, vetId = null) {
  const apiInstance = userRole === "client" ? esupplyvetApi : api;
  
  let url = "/shipping-methods";
  
  if (userRole === "delegues") {
    // Add query parameters for delegates
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    if (vetId) {
      params.append('vetId', vetId);
    }
    url += `?${params.toString()}`;
  }
  
  return apiInstance.get(url);
}
/************************Module Adresses****************************************/
export function CreateNewAdressClient(payload,userRole = null, vetId = null) {
  
  let url = "/addresses";
  
  if (userRole === "delegues") {
    // Add query parameters for delegates
    const params = new URLSearchParams();
    params.append('isDelegate', '1');
    if (vetId) {
      params.append('vetId', vetId);
    }
    url += `?${params.toString()}`;
  }
  const response = getHttpClient().post(url, payload);
  return response;
}
export function UpdateAdressClient(payload) {
  const response = getHttpClient().put(`/addresses/${payload.id}`, payload);
  return response;
}
export function DeleteAdressClient(id) {
  const response = getHttpClient().delete(`/addresses/${id}`);
  return response;
}

// Search products by tag

export async function searchProductsByTag(tag, { page = 1, itemsPerPage = 12 } = {} ,isDelegate = false, vetId = null) {
  try {

      let url = `/products?tagProduit=${encodeURIComponent(tag)}&page=${page}&itemsPerPage=${itemsPerPage}`;
      if (isDelegate && vetId) {
        const params = new URLSearchParams();
        params.append('isDelegate', '1');
        params.append('vetId', vetId);
        url += `&${params.toString()}`;
      }



    const response = await getHttpClient().get(
      url,
      { headers: { Accept: "application/ld+json" } }
    );

    const members = response.data["hydra:member"] || [];
    const total = response.data["hydra:totalItems"] || members.length;

    // Hydra: compute total pages from hydra:totalItems
    const totalPages = Math.ceil(total / itemsPerPage);

    return {
      data: members,
      total,
      pages: totalPages,
    };
  } catch (error) {
    console.error("Error searching products by tag:", error);
    return { data: [], total: 0, pages: 0, view: null };
  }
}



// auth.js
export async function searchProductsByTagHeaderOrName(searchTerm, { signal } = {}, isDelegate = false, vetId = null) {
  try {
    // Create base URLSearchParams
    const params = new URLSearchParams();
    if (isDelegate && vetId) {
      params.append('isDelegate', '1');
      params.append('vetId', vetId);
    }

    // Construct URLs with params for both requests
    const tagUrl = `/products?tagProduit=${encodeURIComponent(searchTerm)}${params.toString() ? '&' + params.toString() : ''}`;
    const nameUrl = `/products?translations.name=${encodeURIComponent(searchTerm)}${params.toString() ? '&' + params.toString() : ''}`;

    // Make separate requests for tag and name search, passing the abort signal
    const [tagResponse, nameResponse] = await Promise.all([
      getHttpClient().get(tagUrl, { signal }).catch(error => {
        // If the error is from an abort, re-throw it. Otherwise, return empty array.
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          throw error;
        }
        return { data: [] }; // Return empty array for other errors (e.g., 404)
      }),
      getHttpClient().get(nameUrl, { signal }).catch(error => {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          throw error;
        }
        return { data: [] };
      })
    ]);

    // If the request was aborted, this code won't run because the Promise.all will reject
    const allResults = [...tagResponse.data, ...nameResponse.data];
    const uniqueResults = Array.from(
      new Map(allResults.map(item => [item.id, item])).values()
    );
    
    return uniqueResults;
  } catch (error) {
    // Re-throw abort errors so the component can handle them specifically
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
      throw error;
    }
    console.error("Error searching products by tag or name:", error);
    return [];
  }


  
}


/**
 * Downloads a document by its ID
 * @param {string|number} documentId - The document ID
 * @returns {Promise<Object>} The document download response with URL or blob
 * @throws {Error} If the request fails
 */


export const downloadDocument = async (documentId) => {
  const httpBaseClient = getHttpClient();
  // On retourne la réponse complète (contient headers ET data/blob)
  return await httpBaseClient.get(
    `/documents/${documentId}/download`,
    { responseType: "blob" }
  );
};
